const api = {
  addCustomerAction() {
    return `/underwriters/actions/add-action`;
  },
  getCustomerActions(controlIdNumber) {
    return `/underwriters/actions/get-actions/${controlIdNumber}`;
  },
  markReviewed() {
    return `/underwriters/actions/mark-reviewed`;
  },
  getAllCustomerActionsForUser() {
    return `/underwriters/actions/get-actions`;
  },
};

export { api };